export default {
  useColorSchemeMediaQuery: false,
  colors: {
    modes: {
      dark: {},
    },
  },
}
